import { Component, Input, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { Account } from '../models/Account';
import { CostDirection } from '../models/CostDirection';
import { CostType } from '../models/CostType';
import { DetailedAccount } from '../models/DetailedAccount';
import { KaizenAccountList } from '../models/Kaizen';
import { PRKaizenMonthlySavingsList } from '../models/kaizen-monthly-savings-list';
import { SavingsMeasure } from '../models/SavingsMeasure';
import { AccountService } from '../Services/Account.Services';
import { CostDirectionService } from '../Services/CostDirection.Services';
import { CostTypeService } from '../Services/CostType.Services';
import { DetailedAccountService } from '../Services/DetailedAccount.Services';
import { KaizenService } from '../Services/Kaizen.Service';
import { SavingsMeasureService } from '../Services/SavingsMeasure.Services';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-multiaccount',
    templateUrl: './multiaccount.component.html',
    styleUrls: ['./multiaccount.component.css'],
    standalone: false
})
export class MultiaccountComponent implements OnInit {
  @Input() kaizenID = 0;
  @Input() implementationYear = '';
  @Input() implementationMonth = '';

  labourcls: string[] = [];
  costDirections!: CostDirection[];
  costTypes!: CostType[];
  accounts!: Account[];
  detailedAccounts !: DetailedAccount[];
  savingsMeasure !: SavingsMeasure[];
  costDirectionsLoaded !: boolean;
  costTypesLoaded !: boolean;
  accountsLoaded !: boolean;
  detailedAccountsLoaded !: boolean;
  savingsMeasureLoaded !: boolean;
  kaizenAccountList: KaizenAccountList[] = [];
  public kaizenAccountArray!: any;
  kaizenMonthlySavingsList!: PRKaizenMonthlySavingsList;
  KaizenMonthlySavingAccountsAry: any[] = [];
  nsProcessReduction: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  nsTwtReduction: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  nsMonthlySavings: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  nsCpuSavings: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  totalCostPerUnit: number[] = [];
  twtReduction: number[] = [];
  processReduction: number[] = [];
  showTotalCostTable: boolean[] = [];
  showCostPerUnitTable: boolean[] = [];
  showProcessReductionTable: boolean[] = [];
  showTotalWorkingTimeReductionTable: boolean[] = [];
  tblNetSavingsShow: boolean = false;
  cumulativePR: number = 0;
  cumulativeMonthlySavings: number = 0;
  tableTotal: number[] = [];
  tableTotalSavings: number[] = [];
  tableTotalVolume: number[] = [];
  tableTotalWorkingDays: number[] = [];
  tableTotalStandardRate: number[] = [];
  tableTotalnumberofShifts: number[] = [];
  tableTotalCapacity: number[] = [];
  tableTotalTWT: number[] = [];
  tableTotalShifts: number[] = [];
  tableTotalLineCapacity: number[] = [];
  tableTotalMonthlySavingstwt: number[] = [];
  tableTotalCPUSavingstwt: number[] = [];
  tableTotalCPUSavings: number[] = [];
  public count: number = 0;
  tableTwtReduction: number[] = [0, 0, 0, 0, 0];
  tableProcessReduction: number[] = [0, 0, 0, 0, 0];
  tabletotalCostPerUnit: number[] = [0, 0, 0, 0, 0];
  viewRate: boolean = false;
  dateHeader: string[] = [];
  multipleCurrencies = false;
  fiscalYear: string = '';
  fiscalYearEnd: number = 0;
  fyText: string = '';
  fyNextText: string = '';
  prCumulativeSavings: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];

  hoursPerShift: number = 8;
  monthList = [
    { Value: 4, Text: 'Apr' },
    { Value: 5, Text: 'May' },
    { Value: 6, Text: 'Jun' },
    { Value: 7, Text: 'Jul' },
    { Value: 8, Text: 'Aug' },
    { Value: 9, Text: 'Sep' },
    { Value: 10, Text: 'Oct' },
    { Value: 11, Text: 'Nov' },
    { Value: 12, Text: 'Dec' },
    { Value: 1, Text: 'Jan' },
    { Value: 2, Text: 'Feb' },
    { Value: 3, Text: 'Mar' }
  ];

  constructor(private CostDirectionService: CostDirectionService,
    private CostTypeService: CostTypeService, private AccountService: AccountService,
    private DetailedAccountService: DetailedAccountService,
    private SavingMeasureService: SavingsMeasureService,
    private KaizenService: KaizenService, private appComp: AppComponent) { }

  ngOnInit() {
    this.getData();
    this.netSavingsTableCalculations();
    
    const role = localStorage.getItem(`adroleNormalized`);
    if (role == 'Viewer' || role == 'Submitter') {
      this.viewRate = false;
    }
    else {
      this.viewRate = true;
    }

  }
  
  getData = async () => {
    await firstValueFrom(this.CostDirectionService.getCostDirections()).then((data) => { this.costDirections = data?.data || []; });
    await firstValueFrom(this.CostTypeService.getCostTypes()).then((data) => { this.costTypes = data?.data || []; });
    await firstValueFrom(this.AccountService.getAccounts(this.appComp.ademail)).then((data) => { this.accounts = data?.data || []; });
    await this.DetailedAccountService.getDetailedAccounts().subscribe(data => this.detailedAccounts = data.data);
    await firstValueFrom(this.SavingMeasureService.getSavingsMeasures()).then((data) => { this.savingsMeasure = data?.data || []; });
    await firstValueFrom(this.KaizenService.getKaizenMonthlySaving(this.kaizenID)).then((data) => {
      this.kaizenMonthlySavingsList = data ?? {} as PRKaizenMonthlySavingsList;
      this.getKaizenAccounts();
      console.log('ms', this.kaizenMonthlySavingsList.data);
    });
    this.getFiscalYear(new Date(this.implementationMonth+'-01-' + this.implementationYear));
    this.fiscalYear = this.getFiscalYear(new Date(this.implementationMonth+'-01-' + this.implementationYear));
    const datex = new Date(this.fiscalYear);
    this.fiscalYearEnd = Number(datex.getFullYear()) + 1;
    this.fyText = this.fiscalYearEnd.toString().substring(2,4);
    this.fyNextText = (this.fiscalYearEnd + 1).toString().substring(2, 4);
  }

  getKaizenAccounts(): void {
    this.KaizenService.getKaizenAccountsByKaizenId(this.kaizenID).subscribe(
      data => {
        this.kaizenAccountArray = data;
        console.log('ka', this.kaizenAccountArray.data);
        let kacl: KaizenAccountList;
        if (this.kaizenAccountArray.data.length > 0) 
        {
          let currentCurrencyCode = this.kaizenAccountArray.data[0].currencyCode;
          for (var i = 0; i <= this.kaizenAccountArray.data.length - 1; i++) {
            if(this.multipleCurrencies || currentCurrencyCode != this.kaizenAccountArray.data[i].currencyCode)
            {
              this.multipleCurrencies = true;
            }
            currentCurrencyCode = this.kaizenAccountArray.data[i].currencyCode;
            kacl = new KaizenAccountList();
            kacl.costDirectionsText = this.costDirections.find(x => x.costDirectionID == this.kaizenAccountArray.data[i].costDirectionId)?.name;
            kacl.accountsText = this.accounts.find(x => x.glAccountImpactAreaId == this.kaizenAccountArray.data[i].glAccountImpactAreaId)?.name;
            kacl.costTypesText = this.costTypes.find(x => x.costTypeID == this.kaizenAccountArray.data[i].costTypeId)?.name;
            kacl.detailedAccountsText = this.detailedAccounts.find(x => x.detailedAccountID == this.kaizenAccountArray.data[i].detailedAccountId)?.detailedAccountName;
            kacl.savingsMeasureText = this.savingsMeasure.find(x => x.savingsMeasureID == this.kaizenAccountArray.data[i].savingsMeasureId)?.savingsMeasureName;
            this.kaizenAccountList.push(kacl);

            this.KaizenMonthlySavingAccountsAry[i] = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[i].kaizenAccountId);

            this.totalCostPerUnit[i] = Number(this.kaizenAccountArray.data[i].costPerUnit);
            this.twtReduction[i] = Number(this.kaizenAccountArray.data[i].twtReduction);
            this.processReduction[i] = Number(this.kaizenAccountArray.data[i].processReduction);
            if (this.kaizenAccountArray.data[i].savingsMeasureName == 'Process Reduction') {
              this.showProcessReductionTable[i] = true;
            }
            if (this.kaizenAccountArray.data[i].savingsMeasureName == "Total Working Time Reduction") {
              this.showTotalWorkingTimeReductionTable[i] = true;
            }
            if (this.kaizenAccountArray.data[i].savingsMeasureName == 'Cost Per Unit') {
              this.showCostPerUnitTable[i] = true;
            }
            if (this.kaizenAccountArray.data[i].savingsMeasureName == 'Total Cost') {
              this.showTotalCostTable[i] = true;
      
            }

            this.calcTableTotal(i);
          }

          this.netSavingsTableCalculations();
        }
      });      
  }

  calcTableTotal(i: number) {
    this.tableTotal[i] = 0;
    this.tableTotalVolume[i] = 0;
    this.tableTotalSavings[i] = 0;
    this.tableTotalCapacity[i] = 0;
    this.tableTotalCPUSavings[i] = 0;
    this.tableTotalTWT[i] = 0;
    this.tableTotalShifts[i] = 0;
    this.tableTotalMonthlySavingstwt[i] = 0;
    this.tableTotalCPUSavingstwt[i] = 0;
    //processCumulativeMonthly is the extended monthly savings due to process reductions
    let processCumulativeMonthly: number = 0;
    //processCumulative is the running cumulative which is assigned to the Cumulative Savings row of the grid 
    let processCumulative: number = 0;

    if (this.KaizenMonthlySavingAccountsAry[i] !== null && this.KaizenMonthlySavingAccountsAry[i].length > 0) {      
      for (let x = 0; x < 12; x++) {        
        if (this.KaizenMonthlySavingAccountsAry[i][x] !== null && this.KaizenMonthlySavingAccountsAry[i][x] !== undefined) {
          this.tableTotal[i] += this.KaizenMonthlySavingAccountsAry[i][x].monthlySavings;
          this.tableTotalVolume[i] += Number(this.KaizenMonthlySavingAccountsAry[i][x].capacity);
          this.tableTotalSavings[i] += (Number(this.KaizenMonthlySavingAccountsAry[i][x].monthlySavings))
          this.tableTotalCapacity[i] += Number(this.KaizenMonthlySavingAccountsAry[i][x].capacity);
          this.tableTotalCPUSavings[i] += Number(this.KaizenMonthlySavingAccountsAry[i][x].costPerUnitSavings);
          this.tableTotalTWT[i] += this.kaizenAccountArray.data[i].twtReduction;
          this.tableTotalShifts[i] += Number(this.KaizenMonthlySavingAccountsAry[i][x].numberOfShifts);
          this.tableTotalMonthlySavingstwt[i] += Number(this.KaizenMonthlySavingAccountsAry[i][x].monthlySavings);
          this.tableTotalCPUSavingstwt[i] += Number(this.KaizenMonthlySavingAccountsAry[i][x].costPerUnitSavings);
          processCumulative += this.KaizenMonthlySavingAccountsAry[i][x].processReduction;
          processCumulativeMonthly +=  Number(this.KaizenMonthlySavingAccountsAry[i][x].standardRate * this.KaizenMonthlySavingAccountsAry[i][x].workingDays * this.KaizenMonthlySavingAccountsAry[i][x].numberOfShifts * this.hoursPerShift *processCumulative);
          this.prCumulativeSavings[i][x] = processCumulativeMonthly;
        }        
      }
    }
  }

  netSavingsTableCalculations() {
    // NET SAVINGS Calculations
    let monthlySavingsIncrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let monthlySavingsDecrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      
    if (this.kaizenAccountArray && this.kaizenAccountArray.data.length > 0) {
      for (var i = 0; i <= this.kaizenAccountArray.data.length - 1; i++) {
        this.cumulativePR = 0;

        if (this.kaizenAccountArray.data[i].savingsMeasureId == 2) { //Proceess Redution
          for (var mIndex = 0; mIndex < 12; mIndex++) {
            if (this.kaizenAccountArray.data[i].costDirectionId == 1) { // Decrease
              this.nsProcessReduction[mIndex] += this.KaizenMonthlySavingAccountsAry[i][mIndex].processReduction + this.cumulativePR;
              this.cumulativePR = this.KaizenMonthlySavingAccountsAry[i][mIndex].processReduction + this.cumulativePR;
            }
            else if (this.kaizenAccountArray.data[i].costDirectionId == 3) { // Increase
              this.nsProcessReduction[mIndex] -= this.KaizenMonthlySavingAccountsAry[i][mIndex].processReduction + this.cumulativePR;
              this.cumulativePR = this.KaizenMonthlySavingAccountsAry[i][mIndex].processReduction + this.cumulativePR;
            }
          }
        }
        if (this.kaizenAccountArray.data[i].savingsMeasureId == 3) { // TWT
          for(var mIndex = 0; mIndex< 12; mIndex++)
          {
            if (this.kaizenAccountArray.data[i].costDirectionId == 1) { // Decrease
              this.nsTwtReduction[mIndex] += this.KaizenMonthlySavingAccountsAry[i][mIndex].twtReduction;
            }
            else if (this.kaizenAccountArray.data[i].costDirectionId == 3) { // Increase
              this.nsTwtReduction[mIndex] -= this.KaizenMonthlySavingAccountsAry[i][mIndex].twtReduction;
            }
          }
        }

        for (var monthIndex = 0; monthIndex < 12; monthIndex++) {
          if (this.kaizenAccountArray.data[i].costDirectionId == 1) {            
            if (this.kaizenAccountArray.data[i].savingsMeasureId == 2) 
            {
              monthlySavingsDecrease[monthIndex] += this.prCumulativeSavings[i][monthIndex];
            }
            else
            {
              if (this.KaizenMonthlySavingAccountsAry[i][monthIndex] !== null && this.KaizenMonthlySavingAccountsAry[i][monthIndex] !== undefined) {
                monthlySavingsDecrease[monthIndex] += this.KaizenMonthlySavingAccountsAry[i][monthIndex].monthlySavings;
              }
            }
          }
          else if (this.kaizenAccountArray.data[i].costDirectionId == 3) {
            
            if (this.kaizenAccountArray.data[i].savingsMeasureId == 2) 
            {
              monthlySavingsIncrease[monthIndex] += this.prCumulativeSavings[i][monthIndex];
            }
            else
            {
              if (this.KaizenMonthlySavingAccountsAry[i][monthIndex] !== null && this.KaizenMonthlySavingAccountsAry[i][monthIndex] !== undefined) {
                monthlySavingsIncrease[monthIndex] += this.KaizenMonthlySavingAccountsAry[i][monthIndex].monthlySavings;
              }
            }
          }
        }
      }

      for(var netSavingsIndex = 0 ; netSavingsIndex < 12; netSavingsIndex++)
      {
        this.nsMonthlySavings[netSavingsIndex] = Number((monthlySavingsDecrease[netSavingsIndex] - monthlySavingsIncrease[netSavingsIndex]).toFixed(2));        
      }
      
      for (var i = 0; i <= this.kaizenAccountArray.data.length - 1; i++) {
        if (this.kaizenAccountArray.data[i].savingsMeasureId != 5) 
        { 
          for (var monthIndex= 0 ; monthIndex< 12; monthIndex ++)
          {
            if (this.KaizenMonthlySavingAccountsAry[i][monthIndex] !== null && this.KaizenMonthlySavingAccountsAry[i][monthIndex] !== undefined) {
              if (this.KaizenMonthlySavingAccountsAry[i][monthIndex].capacity != 0) {
                this.nsCpuSavings[monthIndex] = Number((monthlySavingsDecrease[monthIndex] - monthlySavingsIncrease[monthIndex]) / this.KaizenMonthlySavingAccountsAry[i][monthIndex].capacity);
              }
            }            
          }
        }
      }
      
      if (this.kaizenAccountArray.data.length > 1) {
        this.tblNetSavingsShow = true;
      }
    }
  }

  getFiscalYear(impDate: Date) {
    const mon: number = impDate.getMonth() + 1;
    const yr: number = impDate.getFullYear();
    const fiscYearStart = mon <= 3 ? yr - 1 : yr;
    this.dateHeader = [];
    this.monthList.forEach((mont) => {
      this.dateHeader.push(mont.Text + '-' + (mont.Value <= 3 ? ((fiscYearStart + 1).toString()).substring(2, 4) : (fiscYearStart.toString()).substring(2, 4)));
    });
    return '04-01-' + fiscYearStart;
  }
}